import Toggle from '../../functions/toggle'

const buttons = document.querySelectorAll('.js-collapse-button')

for (let i = 0; i < buttons.length; i++) {
  const collapse = new Toggle({
    trigger: buttons[i],
    target: buttons[i].dataset.target
  })
  collapse.init()
}



// WEBPACK FOOTER //
// ./src/components/collapse/scripts.js